var _defs, _g;
const _excluded = ["title", "titleId"];
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
function _objectWithoutProperties(e, t) { if (null == e) return {}; var o, r, i = _objectWithoutPropertiesLoose(e, t); if (Object.getOwnPropertySymbols) { var n = Object.getOwnPropertySymbols(e); for (r = 0; r < n.length; r++) o = n[r], -1 === t.indexOf(o) && {}.propertyIsEnumerable.call(e, o) && (i[o] = e[o]); } return i; }
function _objectWithoutPropertiesLoose(r, e) { if (null == r) return {}; var t = {}; for (var n in r) if ({}.hasOwnProperty.call(r, n)) { if (-1 !== e.indexOf(n)) continue; t[n] = r[n]; } return t; }
import * as React from "react";
function SvgIconTime(_ref, svgRef) {
  let {
      title,
      titleId
    } = _ref,
    props = _objectWithoutProperties(_ref, _excluded);
  return /*#__PURE__*/React.createElement("svg", _extends({
    xmlns: "http://www.w3.org/2000/svg",
    viewBox: "0 0 20.231 18.703",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _defs || (_defs = /*#__PURE__*/React.createElement("defs", null, /*#__PURE__*/React.createElement("style", null, "\n      .cls-1 {\n        fill: #b53030;\n      }\n    "))), _g || (_g = /*#__PURE__*/React.createElement("g", {
    id: "passage-of-time",
    transform: "translate(0 -1.775)"
  }, /*#__PURE__*/React.createElement("g", {
    id: "Layer_1_65_",
    transform: "translate(0 1.775)"
  }, /*#__PURE__*/React.createElement("g", {
    id: "Group_176",
    "data-name": "Group 176"
  }, /*#__PURE__*/React.createElement("path", {
    id: "Path_109",
    "data-name": "Path 109",
    className: "cls-1",
    d: "M20.19,9.671a.426.426,0,0,0-.386-.245h-1.26A9.344,9.344,0,1,0,17.451,15.8a.85.85,0,0,0-1.472-.852,7.659,7.659,0,1,1,.826-5.526h-1.25a.425.425,0,0,0-.327.7l2.125,2.55a.425.425,0,0,0,.653,0l2.125-2.55A.425.425,0,0,0,20.19,9.671Z",
    transform: "translate(0 -1.775)"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Path_110",
    "data-name": "Path 110",
    className: "cls-1",
    d: "M19.758,6.713a.85.85,0,0,0-.85.85v5.158a1.486,1.486,0,0,0,.851,2.706,1.469,1.469,0,0,0,.628-.144l2.957,1.707a.841.841,0,0,0,.424.114.85.85,0,0,0,.425-1.586l-2.96-1.709a1.481,1.481,0,0,0-.624-1.087V7.563A.852.852,0,0,0,19.758,6.713Zm0,7.864a.637.637,0,1,1,.637-.637A.638.638,0,0,1,19.758,14.577Z",
    transform: "translate(-10.406 -4.588)"
  }))))));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgIconTime);
export default __webpack_public_path__ + "static/media/icon_time.8cfde3bac743eda0a75ec910faabe215.svg";
export { ForwardRef as ReactComponent };